/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Rail_BookInputs */

const en_how_page_rail_book = /** @type {(inputs: How_Page_Rail_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book`)
};

const pl_how_page_rail_book = /** @type {(inputs: How_Page_Rail_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj`)
};

/**
* | output |
* | --- |
* | "Book" |
*
* @param {How_Page_Rail_BookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_rail_book = /** @type {((inputs?: How_Page_Rail_BookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Rail_BookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_rail_book(inputs)
	return en_how_page_rail_book(inputs)
});